import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { ReactQueryDevtools } from "react-query/devtools";
import { useMediaQuery } from "@mui/material";

interface IMaiContentProps {
  open: boolean;
  drawerwidth: number;
  isTabletOrMobile: boolean;
}

export const MainStyles = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})<IMaiContentProps>(({ theme, open, drawerwidth, isTabletOrMobile }) => ({
  marginTop: "4rem",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: isTabletOrMobile ? 0 : `-${drawerwidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

interface IMainProps {
  open: boolean;
  drawerwidth: number;
  children: React.ReactNode | React.ReactNode[];
}

const Main: React.FunctionComponent<IMainProps> = ({ open, drawerwidth, children }) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <MainStyles open={open} drawerwidth={drawerwidth} isTabletOrMobile={isTablet || isMobile}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </MainStyles>
  );
};

export default Main;
